"use client";

import KbvOddsStatus from "@/components/KbvOddsStatus";

function normalizeTrend(trend) {
  if (trend === "up") return "increased";
  if (trend === "down") return "decreased";
  return trend ?? "unchanged";
}

function getBackgroundClass(normalizedTrend) {
  if (normalizedTrend === "increased") return "kbv-odds-cell--up";
  if (normalizedTrend === "decreased") return "kbv-odds-cell--down";
  return "bg-[var(--theme-foreground)]";
}

export default function OddsCell({ label, value, trend = "unchanged" }) {
  const hasLabel = label != null && label !== "";
  const normalizedTrend = normalizeTrend(trend);
  const bgClass = getBackgroundClass(normalizedTrend);

  return (
    <div className={`group/oc flex overflow-hidden border border-[var(--theme-border)] min-w-[52px] rounded-[4px] py-[4px] px-[2px] cursor-pointer hover:bg-[var(--theme-primary)] hover:border-[var(--theme-primary)] ${bgClass}`}>
      <span className="px-1 py-0.5 text-[9px] text-[var(--theme-text-muted)] whitespace-nowrap flex items-center shrink-0 group-hover/oc:text-[var(--theme-on-primary)]">
        {hasLabel ? label : ""}
      </span>
      <div className="px-0.5 py-0.5 flex-1 flex items-center justify-end gap-0.5 min-w-0 group-hover/oc:text-[var(--theme-on-primary)]">
        <span className="text-[10px] font-medium text-[var(--theme-text)] truncate group-hover/oc:text-[var(--theme-on-primary)]">
          {value}
        </span>
        <KbvOddsStatus trend={normalizedTrend} />
      </div>
    </div>
  );
}
